import { useEffect } from 'react';

import cn from 'classnames';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { Button, ToggleSwitch } from 'components/FormComponents';

import { updateCompany } from 'api/company-slice';

export const AuthenticationSecurity = ({ company, setLoading = () => {} }) => {
  const dispatch = useDispatch();

  const { register, reset, handleSubmit } = useForm();

  const onCompanyUpdate = params => dispatch(updateCompany({ id: company.id, params }));

  useEffect(() => {
    reset({ enforce_two_factor_auth: company.enforce_two_factor_auth });
  }, [company]);

  const onSubmit = async data => {
    setLoading(true);
    await onCompanyUpdate(data);
    setLoading(false);
  };

  return (
    <form className={cn('d-flex', 'justify-content-center')} onSubmit={handleSubmit(onSubmit)}>
      <div className={cn('card--small', 'card', 'card-with-border')}>
        <div className={cn('u-padding--large', 'u-divider-bottom-border')}>
          <div className={cn('u-flex-box', 'u-flex-justify-between', 'u-flex-align-center')}>
            <h1 className="title-2">Authentication Security</h1>
          </div>
          <p className="t-small">
            Edit the authentication security settings of your company below.
          </p>
        </div>
        <div className={cn('background-secondary', 'u-padding')}>
          <div className={cn('card', 'card-with-border', 'u-padding')}>
            <ToggleSwitch
              register={register}
              className="u-margin-bottom--0"
              name="enforce_two_factor_auth"
              tooltip="We recommend notifying the organization members and asking them to enable 2FA for their accounts before enforcing this setting."
              label="Require Two-factor Authentication for all users"
            />
          </div>
        </div>
        <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-end')}>
          <Button submit>Save</Button>
        </div>
      </div>
    </form>
  );
};
